/*
 * @Author: 辰乐 chenxinyu@cai-inc.com
 * @Date: 2024-03-05 15:07:47
 * @LastEditors: 辰乐 chenxinyu@cai-inc.com
 * @LastEditTime: 2024-03-12 13:56:38
 * @FilePath: /zcy-claim-front/src/routes/AttendanceConfig/services/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { query } from 'src/utils/request';

// 查询单位考勤组
export const getAttendConfig = params => {
  return query('/zlb/api/office/attend/group/query', {
    params,
  });
};

// 保存考勤组单条配置
export const updateAttendGroup = data => {
  return query('/zlb/api/office/attend/group/add-single', {
    method: 'POST',
    data,
  });
};

// 保存加班配置，模块保存
export const updateOvertimeConfig = data => {
  return query('/zlb/api/office/overtime/config/save-single', {
    method: 'POST',
    data,
  });
};

// 保存加班配置
export const saveOvertimeConfig = data => {
  return query('/zlb/api/office/overtime/config/save', {
    method: 'POST',
    data,
  });
};
// 查询加班配置
export const queryOvertimeConfig = params => {
  return query('/zlb/api/office/overtime/config/query', {
    params,
  });
};
